module.exports = __webpack_public_path__ + "static/media/cr.fdb730f2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cr.svg
// module id = 2069
// module chunks = 0